import React from "react";

import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import { getQueuedPlates } from "../../../redux/reducers/ImagingScheduleReducer";

import OverviewStatus, { EOverviewModuleStatus } from "../OverviewStatus";

import { EModuleType } from "../../../Model/EModuleType";
import { PlatesWaitingToBeImaged } from "../../../Icons/TopCommandPanel";

const ScheduleStatus = () => {
  const queuedSchedules = useTypedSelector((state) => getQueuedPlates(state));

  const statusess = {
    "To Be Waiting": queuedSchedules.length,
  };

  return (
    <OverviewStatus
      name={"SCHEDULE"}
      statusses={statusess}
      icon={<PlatesWaitingToBeImaged />}
      style={{ order: 7 }}
      moduleType={EModuleType.UNKNOWN}
      moduleStatus={EOverviewModuleStatus.Idle}
    />
  );
};

export default ScheduleStatus;
